export const KbdTheme = {
  baseStyle: {
    background: "transparent",
    borderColor: "text-placeholder",
    color: "text-placeholder",
    padding: "2px 6px",
  },
};
